import { MISSION } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export default function Mission() {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="border-y border-[var(--line)] bg-[#eae7dd]"
    >
      <div className="mx-auto max-w-[1200px] px-6 py-28 md:px-10 md:py-44">
        <Reveal className="flex items-center justify-center gap-5">
          <span className="h-px w-10 bg-[#9c7a33]/60" />
          <Eyebrow testid="mission-eyebrow">{MISSION.eyebrow}</Eyebrow>
          <span className="h-px w-10 bg-[#9c7a33]/60" />
        </Reveal>
        <Reveal delay={0.12}>
          <div className="relative mx-auto mt-14 max-w-4xl">
            <span className="pointer-events-none absolute -top-12 left-0 font-display text-8xl leading-none text-[#9c7a33]/30 md:-left-10">
              “
            </span>
            <p className="text-center font-display text-3xl font-light leading-[1.15] tracking-tight text-[#1c2b4a] md:text-5xl lg:text-[3.4rem]">
              {MISSION.statement}
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-10 max-w-xl text-center text-base leading-relaxed text-[#5c6474] md:text-lg">
            {MISSION.supporting}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
